import { render, staticRenderFns } from "./logList.vue?vue&type=template&id=05535822&scoped=true&"
import script from "./logList.vue?vue&type=script&lang=js&"
export * from "./logList.vue?vue&type=script&lang=js&"
import style0 from "./logList.vue?vue&type=style&index=0&id=05535822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05535822",
  null
  
)

export default component.exports